// Resolves whether a record (shipping address, payment profile, ...) is active.
// Supports the shapes the API may return: boolean `active`/`enabled`, a `status`/`vindiStatus`
// enum (e.g. ACTIVE/INACTIVE) or a soft-delete `deletedAt` timestamp.
// Returns null when the record carries no status information at all.
export const isRecordActive = (record) => {
  if (!record) {
    return null
  }

  if (typeof record.active === 'boolean') {
    return record.active
  }

  if (typeof record.enabled === 'boolean') {
    return record.enabled
  }

  const status = record.status ?? record.vindiStatus
  if (typeof status === 'string') {
    return status.toUpperCase() === 'ACTIVE'
  }

  if ('deletedAt' in record) {
    return record.deletedAt == null
  }

  return null
}

export const inactiveLabelSuffix = (record) => {
  return isRecordActive(record) === false ? ' (inativo)' : ''
}
